var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 6.24967H6.2513C5.69877 6.24967 5.16886 6.03018 4.77816 5.63948C4.38746 5.24878 4.16797 4.71888 4.16797 4.16634C4.16797 3.61381 4.38746 3.0839 4.77816 2.6932C5.16886 2.3025 5.69877 2.08301 6.2513 2.08301C9.16797 2.08301 10.0013 6.24967 10.0013 6.24967ZM10.0013 6.24967H13.7513C14.3038 6.24967 14.8337 6.03018 15.2244 5.63948C15.6151 5.24878 15.8346 4.71888 15.8346 4.16634C15.8346 3.61381 15.6151 3.0839 15.2244 2.6932C14.8337 2.3025 14.3038 2.08301 13.7513 2.08301C10.8346 2.08301 10.0013 6.24967 10.0013 6.24967ZM10.0013 6.24967L10.0013 18.7497M1.66797 12.083H18.3346M1.66797 8.91634L1.66797 16.083C1.66797 17.0164 1.66797 17.4831 1.84962 17.8397C2.00941 18.1533 2.26438 18.4082 2.57798 18.568C2.9345 18.7497 3.40121 18.7497 4.33463 18.7497L15.668 18.7497C16.6014 18.7497 17.0681 18.7497 17.4246 18.568C17.7382 18.4082 17.9932 18.1533 18.153 17.8397C18.3346 17.4831 18.3346 17.0164 18.3346 16.083V8.91634C18.3346 7.98292 18.3346 7.51621 18.153 7.15969C17.9932 6.84609 17.7382 6.59112 17.4246 6.43133C17.0681 6.24968 16.6014 6.24968 15.668 6.24968L4.33464 6.24967C3.40122 6.24967 2.9345 6.24967 2.57798 6.43133C2.26438 6.59112 2.00941 6.84609 1.84962 7.15969C1.66797 7.51621 1.66797 7.98292 1.66797 8.91634Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.5c57dd56d36b16f5853b6337ae8b8940.svg";
export { ForwardRef as ReactComponent };